import axios from 'axios';

export default class ConfigService {
  constructor() {}
  public init(callback: Function): void {
    let url = (window as any).configPath || 'serverConfig.json';
    // 兼容 微前端 加载前端配置文件
    if ((window as any).__POWERED_BY_QIANKUN__ && url === 'serverConfig.json') {
      url = `${process.env.VUE_APP_BASE}serverConfig.json`
    } else if (url === 'serverConfig.json') {
      // history 模式下需要使用绝对路径，确保从根路径加载配置文件
      // 如果有 VUE_APP_BASE，则使用它；否则使用绝对路径
      if (process.env.VUE_APP_BASE) {
        url = `${process.env.VUE_APP_BASE}serverConfig.json`;
      } else {
        // 确保使用绝对路径，以 / 开头
        url = url.startsWith('/') ? url : `/${url}`;
      }
    }
    axios.get(url).then((result:any) => {
      callback(result);
    }).catch(error => {
      console.error('加载配置文件失败:', error);
      callback(error);
      throw error;
    });
  }
}
